import { Component, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { AbcLoginComponent } from '@barthauer/abc/core/authentication';

@Component({
  selector: 'basys-authentication-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LoginComponent {
  @Input() displaySpecialLogin: boolean;
  public needsPasswordChange: boolean = false;

  @ViewChild('abcLoginComponent') abcLoginComponent: AbcLoginComponent;

  constructor() {}
}
